import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { doc, updateDoc } from 'firebase/firestore';
import { db, auth } from '../../config/firebase';

const languages = [
    { code: 'es', label: 'Español', countryCode: 'es' },
    { code: 'en', label: 'English', countryCode: 'gb' },
    { code: 'fr', label: 'Français', countryCode: 'fr' },
    { code: 'de', label: 'Deutsch', countryCode: 'de' },
    { code: 'it', label: 'Italiano', countryCode: 'it' },
    { code: 'pt', label: 'Português', countryCode: 'pt' }
];

const LanguageSwitcher = ({ direction = 'down', align = 'right' }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);

    const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

    const changeLanguage = async (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);

        // Save language preference to Firestore if user is logged in
        const user = auth.currentUser;
        if (user) {
            try {
                const userRef = doc(db, 'users', user.uid);
                await updateDoc(userRef, { preferredLanguage: lng });
            } catch (error) {
                console.error('Error saving language preference:', error);
            }
        }
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-neutral-900 hover:bg-neutral-800 transition-colors text-sm text-gray-300 max-w-full"
            >
                <Globe size={16} className="text-white shrink-0" />
                <img
                    src={`https://flagcdn.com/w40/${currentLang.countryCode}.png`}
                    srcSet={`https://flagcdn.com/w80/${currentLang.countryCode}.png 2x`}
                    width="20"
                    height="15"
                    alt=""
                    aria-hidden="true"
                    className="rounded-sm object-cover shrink-0"
                />
                <span className="hidden md:inline truncate">{currentLang.label}</span>
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />
                    <div className={`absolute ${align === 'left' ? 'left-0' : 'right-0'} ${direction === 'up' ? 'bottom-full mb-2' : 'top-full mt-2'} w-48 bg-neutral-900 border border-neutral-800 rounded-xl shadow-xl z-50 overflow-hidden`}>
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                onClick={() => changeLanguage(lang.code)}
                                className={`w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-neutral-800 transition-colors ${i18n.language === lang.code ? 'text-red-500 bg-red-500/10' : 'text-gray-300'
                                    }`}
                            >
                                <img
                                    src={`https://flagcdn.com/w40/${lang.countryCode}.png`}
                                    srcSet={`https://flagcdn.com/w80/${lang.countryCode}.png 2x`}
                                    width="20"
                                    height="15"
                                    alt=""
                                    aria-hidden="true"
                                    className="rounded-sm object-cover"
                                />
                                <span>{lang.label}</span>
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default LanguageSwitcher;
